import React from 'react';

import { Typography, Toolbar, Button, Box } from '@mui/material';
import { lighten } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { Alert } from '@mui/material';

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. Unsupported arrow function syntax.
//Unexpected value type of ConditionalExpression.
const useToolbarStyles = makeStyles()((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('lg')]: {
      minHeight: '54px',
    },
  },
  btnPayCommission: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
          color: theme.palette.primary.main,
          backgroundColor: lighten(theme.palette.success.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },

  exportButton: { marginLeft: theme.spacing(2) },
}));

function UnifyCustomerAutomaticToolbar({ selectedIndexes, contactListLength, onSave }) {
  const { classes, cx } = useToolbarStyles();

  return (
    <Toolbar
      className={cx(classes.root, {
        [classes.highlight]: selectedIndexes.length > 0,
      })}
    >
      {selectedIndexes.length > 0 ? (
        <Box display="flex" flexDirection="row" alignItems="center">
          <Typography color="inherit" variant="subtitle1" component="div">
            {selectedIndexes.length} de {contactListLength} selecionados
          </Typography>
        </Box>
      ) : (
        <>
          {contactListLength > 0 ? (
            <Alert severity="info">
              <Typography variant="body1">Selecione um ou mais contatos para unificar</Typography>
            </Alert>
          ) : (
            <div></div>
          )}
        </>
      )}

      <div>
        <Button
          variant="contained"
          className={classes.btnPayCommission}
          onClick={() => {
            onSave(selectedIndexes);
          }}
          disabled={selectedIndexes.length === 0}
        >
          Unificar Contatos
        </Button>
      </div>
    </Toolbar>
  );
}

export default UnifyCustomerAutomaticToolbar;
